<template>
  <div class="mrc-page">
    <div class="mrc-hero">
      <div>
        <span class="mrc-hero__kicker">{{
          isMyProcesses ? "Seguimiento Masivo" : "Reclutamiento masivo"
        }}</span>
        <h1 class="mrc-hero__title">
          {{
            isMyProcesses ? "Mis Procesos Masivos" : "Convocatoria por campaña"
          }}
        </h1>
        <p class="mrc-hero__subtitle">
          {{
            isMyProcesses
              ? "Gestiona y cita a los postulantes de los puestos que tienes asignados."
              : "Un solo enlace por campaña, validado por fechas."
          }}
        </p>
      </div>
      <div class="mrc-hero__badge">
        {{ isMyProcesses ? "Mis Procesos" : "Masivo" }}
      </div>
    </div>

    <v-container class="mrc-container">
      <v-card
        v-if="!isMyProcesses"
        class="mrc-card mrc-card--composer"
        outlined
      >
        <div class="mrc-card__header">
          <div>
            <h3>Aperturar convocatoria</h3>
            <span>Campañas con requerimientos masivos aprobados</span>
          </div>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="5">
              <s-select-campaign-se
                label="Campaña"
                v-model="massiveForm.CmpID"
                clearable
              />
            </v-col>
            <v-col cols="12" md="5">
              <s-text
                label="Descripción"
                v-model="massiveForm.MrcDescription"
              />
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-end">
              <v-btn
                color="primary"
                :loading="savingMassive"
                block
                @click="createMassive"
              >
                Crear
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
        v-if="selectedMassive"
        class="mrc-card mrc-card--selected"
        outlined
      >
        <div class="mrc-card__header">
          <div>
            <h3>Convocatoria seleccionada</h3>
            <span>Los postulantes de abajo cambian según la fila elegida</span>
          </div>
        </div>
        <v-card-text>
          <div class="mrc-detail mrc-detail--selected">
            <div>
              <span>Campaña</span>
              <strong>{{ selectedMassive.CmpName }}</strong>
            </div>
            <div>
              <span>Estado</span>
              <strong>{{ selectedMassive.MrcStatusName || "Abierta" }}</strong>
            </div>
            <div>
              <span>UUID</span>
              <strong>{{ selectedMassive.MrcUUID }}</strong>
            </div>
            <div>
              <span>Enlace público</span>
              <a :href="getPublicLink(selectedMassive)" target="_blank">{{
                getPublicLink(selectedMassive)
              }}</a>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mrc-card" outlined>
        <s-crud
          ref="scrudMassive"
          no-border
          search-input
          :title="
            isMyProcesses ? 'Convocatorias asignadas' : 'Convocatorias masivas'
          "
          :config="configMassive"
          :add="false"
          :edit="false"
          :remove="false"
          :refreshTable="refreshMassiveTable"
          height="330px"
          @rowSelected="onMassiveSelected"
        >
          <template v-slot:[`item.MrcStatus`]="{ item }">
            <v-chip
              x-small
              :color="statusColor(item.MrcStatus)"
              text-color="white"
            >
              {{ item.MrcStatusName || "Desconocido" }}
            </v-chip>
          </template>
          <template v-slot:[`item.PublicLink`]="{ item }">
            <a :href="getPublicLink(item)" target="_blank">Abrir enlace</a>
          </template>
        </s-crud>
      </v-card>

      <v-row>
        <v-col cols="12" :md="activeChatApplicant ? 7 : 12">
          <v-card class="mrc-card mrc-card--applicants" outlined>
            <s-crud
              ref="scrudApplicants"
              no-border
              search-input
              :title="
                isMyProcesses
                  ? 'Postulantes a mis puestos asignados'
                  : 'Postulantes de convocatoria masiva'
              "
              :config="configApplicants"
              :add="false"
              :edit="false"
              :remove="false"
              :rowDefault="false"
              :singleRow="false"
              :showCount="true"
              :filter="filterApplicants"
              :refreshTable="refreshApplicantsTable"
              height="430px"
              @rowSelected="onApplicantsSelected"
            >
              <template v-slot:filter>
                <v-row dense class="mt-2">
                  <v-col cols="12" md="3">
                    <s-select-definition
                      v-model="filterTypeProcess"
                      :def="1077"
                      label="Proceso"
                      outlined
                      dense
                      clearable
                      :disabled="!selectedMassive"
                      @change="onTypeProcessChange"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <s-select
                      v-model="filterApplicants.PstID"
                      :items="filteredPositions"
                      item-text="PstName"
                      item-value="PstID"
                      label="Cargo de la campaña"
                      outlined
                      dense
                      clearable
                      :disabled="!selectedMassive"
                      @change="applyApplicantsFilter"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <s-select
                      v-model="filterApplicants.IsOldWorker"
                      :items="oldWorkerOptions"
                      item-text="text"
                      item-value="value"
                      label="Trabajador Antiguo"
                      outlined
                      dense
                      clearable
                      :disabled="!selectedMassive"
                      @change="applyApplicantsFilter"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <s-select
                      v-model="filterApplicants.HasAdmonition"
                      :items="admonitionFilterOptions"
                      item-text="text"
                      item-value="value"
                      label="Amonestación / Falta"
                      outlined
                      dense
                      clearable
                      :disabled="!selectedMassive"
                      @change="applyApplicantsFilter"
                    />
                  </v-col>
                </v-row>
              </template>
              <template v-slot:options>
                <v-btn
                  small
                  color="success"
                  class="mr-2"
                  :disabled="
                    !canSendWhatsApp || filterApplicants.PstID === null
                  "
                  @click="openWhatsAppDialog"
                >
                  Citar / Registrar Invitación ({{ selectedApplicants.length }})
                </v-btn>
              </template>
              <template v-slot:[`item.FullName`]="{ item }">
                <div class="d-flex align-center flex-wrap">
                  <span class="font-weight-medium mr-1">{{
                    item.FullName
                  }}</span>
                  <v-tooltip top v-if="item.HasPendingInvitation">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        x-small
                        color="amber darken-2"
                        text-color="white"
                        class="ml-1 font-weight-bold"
                        v-bind="attrs"
                        v-on="on"
                        style="height: 18px"
                      >
                        Citado:
                        {{
                          item.PendingInvitationDate
                            ? $moment(item.PendingInvitationDate).format(
                                "DD/MM",
                              )
                            : ""
                        }}
                      </v-chip>
                    </template>
                    <span
                      >Invitado para el
                      {{
                        item.PendingInvitationDate
                          ? $moment(item.PendingInvitationDate).format(
                              "DD/MM/YYYY",
                            )
                          : ""
                      }}</span
                    >
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:[`item.PpnNumberPhone`]="{ item }">
                <div class="d-flex align-center" v-if="item.PpnNumberPhone">
                  <v-icon x-small color="teal" class="mr-1"
                    >mdi-phone-outline</v-icon
                  >
                  <span class="text-caption font-weight-bold">{{
                    item.PpnNumberPhone
                  }}</span>
                </div>
                <span v-else class="grey--text text-caption">-</span>
              </template>
              <template v-slot:[`item.PemEmail`]="{ item }">
                <div
                  class="d-flex align-center"
                  v-if="item.PemEmail"
                  :title="item.PemEmail"
                >
                  <v-icon x-small color="indigo" class="mr-1"
                    >mdi-email-outline</v-icon
                  >
                  <span
                    class="text-caption text-truncate"
                    style="max-width: 170px"
                    >{{ item.PemEmail }}</span
                  >
                </div>
                <span v-else class="grey--text text-caption">-</span>
              </template>
              <template v-slot:[`item.HasAdmonition`]="{ item }">
                <v-chip
                  v-if="item.HasAdmonition"
                  x-small
                  color="amber darken-3"
                  text-color="white"
                  class="font-weight-bold cursor-pointer"
                  @click.stop="openAdmonitionDialog(item)"
                  title="Clic para ver detalle de la falta / amonestación"
                >
                  <v-icon left x-small>mdi-alert-circle</v-icon>
                  Falta
                </v-chip>
                <span v-else class="grey--text text-caption">-</span>
              </template>
              <template v-slot:[`item.IsOldWorker`]="{ item }">
                <v-chip
                  x-small
                  :color="
                    item.IsOldWorker ? 'purple darken-1' : 'grey lighten-2'
                  "
                  :text-color="item.IsOldWorker ? 'white' : 'grey darken-3'"
                  class="font-weight-bold"
                >
                  {{ item.IsOldWorker ? "Sí" : "No" }}
                </v-chip>
              </template>
              <template v-slot:[`item.PmaStatus`]="{ item }">
                <v-chip
                  x-small
                  :color="applicantStatusColor(item.PmaStatus)"
                  text-color="white"
                >
                  {{ item.PmaStatusName }}
                </v-chip>
              </template>
              <template v-slot:[`item.TypeSex`]="{ item }">
                <span>{{
                  item.TypeSex === 1
                    ? "Masculino"
                    : item.TypeSex === 2
                    ? "Femenino"
                    : "-"
                }}</span>
              </template>
              <template v-slot:[`item.PositionIDsJSON`]="{ item }">
                <span>{{ formatPositionJson(item.PositionIDsJSON) }}</span>
              </template>
              <template v-slot:[`item.Actions`]="{ item }">
                <v-tooltip top v-if="item.HasAdmonition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="openAdmonitionDialog(item)"
                    >
                      <v-icon color="amber darken-3">mdi-gavel</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalle de amonestaciones</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="openChat(item)"
                    >
                      <v-icon color="teal">mdi-whatsapp</v-icon>
                    </v-btn>
                  </template>
                  <span>Chat de WhatsApp</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="openDiagnosisTimeline(item)"
                    >
                      <v-icon color="indigo">mdi-timeline-text-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver línea de tiempo de diagnósticos (5 años)</span>
                </v-tooltip>
              </template>
            </s-crud>
          </v-card>
        </v-col>

        <!-- Chat Panel -->
        <v-col cols="12" md="5" v-if="activeChatApplicant">
          <v-card class="mrc-card mrc-card--chat" outlined>
            <div class="mrc-chat-header">
              <div class="d-flex align-center">
                <v-avatar color="teal lighten-4" size="36" class="mr-2">
                  <span class="teal--text font-weight-bold">{{
                    activeChatApplicant.FullName.charAt(0)
                  }}</span>
                </v-avatar>
                <div>
                  <div class="font-weight-bold text-subtitle-2">
                    {{ activeChatApplicant.FullName }}
                  </div>
                  <div class="grey--text text-caption">
                    Telf: {{ activeChatApplicant.PpnNumberPhone }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-center">
                <v-btn icon small @click="closeChat">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Position choices of applicant -->
            <div
              class="mrc-chat-positions-bar px-3 py-2 grey lighten-4 border-bottom"
            >
              <span
                class="text-caption font-weight-bold grey--text text--darken-1"
                >Postula a:</span
              >
              <v-chip
                x-small
                class="ml-1"
                color="indigo"
                text-color="white"
                v-for="(pos, i) in getAppliedPositionsList(activeChatApplicant)"
                :key="i"
              >
                {{ pos }}
              </v-chip>
            </div>

            <div class="mrc-chat-messages" ref="chatContainer">
              <div v-if="chatLoading" class="d-flex justify-center my-4">
                <v-progress-circular indeterminate color="primary" size="24" />
              </div>
              <div
                v-else-if="chatMessages.length === 0"
                class="text-center grey--text my-4 text-caption"
              >
                No hay mensajes en este chat.
              </div>
              <div
                v-else
                v-for="msg in chatMessages"
                :key="msg.EventID"
                class="mrc-chat-bubble-wrapper"
                :class="msg.SendStatus === 5 ? 'inbound' : 'outbound'"
              >
                <div class="mrc-chat-bubble">
                  <div
                    class="mrc-chat-bubble-meta font-weight-bold"
                    v-if="
                      msg.TemplateName && msg.TemplateName !== 'CUSTOM_TEXT'
                    "
                  >
                    Plantilla: {{ msg.TemplateName }}
                  </div>
                  <div class="mrc-chat-bubble-text">
                    {{ msg.ReplyText || "(Mensaje de plantilla enviado)" }}
                  </div>
                  <div
                    class="mrc-chat-bubble-time d-flex align-center justify-end"
                  >
                    <span>{{ formatChatTime(msg.SentAt) }}</span>
                    <v-icon
                      x-small
                      class="ml-1"
                      v-if="msg.SendStatus === 4"
                      color="blue"
                      >mdi-eye</v-icon
                    >
                    <v-icon
                      x-small
                      class="ml-1"
                      v-else-if="msg.SendStatus === 3"
                      color="grey"
                      >mdi-check-all</v-icon
                    >
                    <v-icon
                      x-small
                      class="ml-1"
                      v-else-if="msg.SendStatus === 1"
                      color="grey"
                      >mdi-check</v-icon
                    >
                    <v-icon
                      x-small
                      class="ml-1"
                      v-else-if="msg.SendStatus === 2"
                      color="error"
                      >mdi-alert-circle</v-icon
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              class="mrc-chat-footer px-3 py-2 d-flex align-center border-top"
            >
              <v-text-field
                v-model="chatText"
                placeholder="Escribe un mensaje de WhatsApp..."
                outlined
                dense
                hide-details
                class="mr-2 rounded-lg"
                @keyup.enter="sendChatMessage"
              />
              <v-btn
                color="teal"
                dark
                fab
                x-small
                :loading="sendingChat"
                @click="sendChatMessage"
              >
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="whatsAppDialog" max-width="820" persistent>
        <v-card>
          <div class="mrc-card__header">
            <div>
              <h3>Citar / Registrar Invitación</h3>
              <span
                >Se registrará la citación y se enviará la invitación a
                {{ selectedApplicants.length }} postulante(s)</span
              >
            </div>
            <v-btn
              icon
              @click="closeWhatsAppDialog"
              :disabled="sendingWhatsApp"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-radio-group v-model="whatsAppForm.channel" row class="mt-0 mb-3">
              <v-radio
                label="Correo Electrónico (Predeterminado)"
                value="email"
                color="primary"
              ></v-radio>
              <v-radio label="WhatsApp" value="whatsapp" color="teal"></v-radio>
            </v-radio-group>
            <v-row>
              <v-col cols="12" :md="whatsAppForm.channel === 'email' ? 3 : 6">
                <s-date
                  v-model="whatsAppForm.dateText"
                  label="Fecha"
                  outlined
                  dense
                  placeholder="31/03/2026"
                />
              </v-col>
              <v-col cols="12" :md="whatsAppForm.channel === 'email' ? 3 : 6">
                <s-time
                  landscape
                  v-model="whatsAppForm.timeText"
                  label="Hora"
                  outlined
                  dense
                  placeholder="08:00 am"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="whatsAppForm.channel === 'email'">
                <s-text
                  v-model="whatsAppForm.addressText"
                  label="Lugar / Dirección de presentación"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-alert
              type="info"
              dense
              outlined
              v-if="whatsAppForm.channel === 'email'"
            >
              Se enviará la invitación con plantilla oficial a los postulantes
              con correo electrónico válido.
            </v-alert>
            <v-alert type="info" dense outlined v-else>
              Solo se citará y enviará WhatsApp a postulantes con teléfono
              válido (9 dígitos o con prefijo 51).
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text :disabled="sendingWhatsApp" @click="closeWhatsAppDialog"
              >Cancelar</v-btn
            >
            <v-btn
              :color="whatsAppForm.channel === 'whatsapp' ? 'teal' : 'primary'"
              dark
              :loading="sendingWhatsApp"
              :disabled="!canSendWhatsApp"
              @click="sendWhatsAppTemplate"
            >
              {{
                whatsAppForm.channel === "whatsapp"
                  ? "Confirmar Citación por WhatsApp"
                  : "Confirmar Citación por Correo"
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Bulk Select Dialog -->
      <v-dialog v-model="bulkSelectDialog" max-width="500" persistent>
        <v-card class="rounded-xl">
          <div class="mrc-card__header px-6 pt-6">
            <div>
              <h3 class="text-h6 font-weight-bold">
                Seleccionar Postulante(s)
              </h3>
              <span class="text-caption grey--text"
                >Asignar postulante(s) al proceso de reclutamiento
                correspondiente</span
              >
            </div>
          </div>
          <v-card-text class="px-6 pt-4">
            <v-alert type="info" dense outlined text class="mb-4">
              Se procesará la selección de
              <strong>{{ selectedApplicantsForBulk.length }}</strong>
              postulante(s).
            </v-alert>
            <s-select
              label="Proceso de Reclutamiento"
              v-model="bulkSelectForm.RprID"
              :items="processOptions"
              item-text="text"
              item-value="value"
              clearable
              outlined
              dense
              @change="onBulkSelectProcessChanged"
            />
            <s-select
              label="Cargo Específico (Opcional)"
              v-model="bulkSelectForm.PstID"
              :items="bulkSelectPositions"
              item-text="PstName"
              item-value="PstID"
              clearable
              outlined
              dense
              :disabled="!bulkSelectForm.RprID"
              hint="Si no se selecciona, se usará el cargo por defecto de la convocatoria"
              persistent-hint
              class="mt-2"
            />
          </v-card-text>
          <v-card-actions class="px-6 pb-6 pt-2">
            <v-spacer />
            <v-btn
              text
              @click="bulkSelectDialog = false"
              :disabled="submittingBulkSelect"
              >Cancelar</v-btn
            >
            <v-btn
              color="teal"
              dark
              class="px-6 rounded-lg"
              :loading="submittingBulkSelect"
              @click="confirmBulkSelect"
            >
              Confirmar Selección
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Bulk Select Results Dialog -->
      <v-dialog v-model="bulkSelectResultsDialog" max-width="600" persistent>
        <v-card class="rounded-xl">
          <div class="mrc-card__header px-6 pt-6">
            <div>
              <h3 class="text-h6 font-weight-bold">
                Resultado de Selección Masiva
              </h3>
              <span class="text-caption grey--text"
                >Detalle del procesamiento de selección</span
              >
            </div>
          </div>
          <v-card-text class="px-6 pt-4">
            <v-simple-table dense class="border rounded-lg overflow-hidden">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Postulante</th>
                    <th class="text-left" style="width: 120px">DNI</th>
                    <th class="text-left" style="width: 120px">Estado</th>
                    <th class="text-left">Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in bulkSelectResults" :key="row.PmaID">
                    <td>{{ row.FullName }}</td>
                    <td>{{ row.DocumentNumber }}</td>
                    <td>
                      <v-chip
                        x-small
                        :color="row.Status === 'OK' ? 'success' : 'error'"
                        text-color="white"
                      >
                        {{ row.Status }}
                      </v-chip>
                    </td>
                    <td
                      class="text-caption font-weight-medium"
                      :class="row.Status === 'OK' ? 'teal--text' : 'red--text'"
                    >
                      {{ row.Message }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="px-6 pb-6 pt-2">
            <v-spacer />
            <v-btn
              color="primary"
              class="px-6 rounded-lg"
              @click="bulkSelectResultsDialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- WhatsApp / Email Send Results Dialog -->
      <v-dialog v-model="whatsAppResultsDialog" max-width="600" persistent>
        <v-card class="rounded-xl">
          <div class="mrc-card__header px-6 pt-6">
            <div>
              <h3 class="text-h6 font-weight-bold">Resultados del Envío</h3>
              <span class="text-caption grey--text"
                >Detalle de los postulantes no procesados</span
              >
            </div>
          </div>
          <v-card-text class="px-6 pt-4">
            <v-simple-table dense class="border rounded-lg overflow-hidden">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Postulante</th>
                    <th class="text-left" style="width: 140px">Contacto</th>
                    <th class="text-left">Detalle / Motivo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in whatsAppResults" :key="idx">
                    <td>{{ row.name }}</td>
                    <td>{{ row.phone || row.email || "-" }}</td>
                    <td class="text-caption font-weight-medium red--text">
                      {{ row.error }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="px-6 pb-6 pt-2">
            <v-spacer />
            <v-btn
              color="primary"
              class="px-6 rounded-lg"
              @click="whatsAppResultsDialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="timelineDialog" max-width="720px" scrollable>
      <v-card flat style="border-radius: 12px; overflow: hidden">
        <!-- Header compacto -->
        <div
          style="
            background: #3730a3;
            padding: 14px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div>
            <div
              style="
                font-size: 13px;
                font-weight: 500;
                color: #fff;
                letter-spacing: 0.02em;
              "
            >
              Línea de tiempo de diagnósticos
            </div>
            <div
              style="
                font-size: 11px;
                color: rgba(255, 255, 255, 0.65);
                margin-top: 2px;
              "
            >
              {{ timelineWorkerName || "Trabajador" }}
            </div>
          </div>
          <v-btn
            icon
            small
            @click="timelineDialog = false"
            style="background: rgba(255, 255, 255, 0.12)"
          >
            <v-icon small color="white">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text
          style="
            max-height: 65vh;
            padding: 16px 20px;
            display: flex;
            flex-direction: column;
            gap: 8px;
          "
        >
          <v-progress-linear
            v-if="timelineLoading"
            indeterminate
            color="indigo"
            class="mb-2"
          />

          <v-alert
            v-if="!timelineLoading && timelineItems.length === 0"
            type="info"
            text
            dense
          >
            No se encontraron diagnósticos en los últimos 5 años.
          </v-alert>

          <!-- Entradas de timeline -->
          <template v-if="!timelineLoading && timelineItems.length > 0">
            <div
              v-for="(item, idx) in timelineItems"
              :key="`${item.MevDate}-${idx}`"
              style="
                display: grid;
                grid-template-columns: 90px 1fr;
                border: 0.5px solid rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                overflow: hidden;
              "
            >
              <!-- Columna de fecha -->
              <div
                style="
                  background: #f8f8f7;
                  padding: 14px 12px;
                  border-right: 0.5px solid rgba(0, 0, 0, 0.1);
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div>
                  <div
                    style="
                      font-size: 22px;
                      font-weight: 500;
                      color: #1a1a1a;
                      line-height: 1.1;
                    "
                  >
                    {{ $fun.formatDateView(item.MevDate).split("/")[0] }}
                  </div>
                  <div
                    style="
                      font-size: 10px;
                      color: #888;
                      letter-spacing: 0.08em;
                      text-transform: uppercase;
                      margin-top: 2px;
                    "
                  >
                    {{ getMonthLabel(item.MevDate) }}
                  </div>
                </div>
                <div style="font-size: 10px; color: #aaa; margin-top: 12px">
                  {{ item.Diagnoses.length }} dx
                </div>
              </div>

              <!-- Columna de contenido -->
              <div
                style="
                  padding: 12px 14px;
                  display: flex;
                  flex-direction: column;
                  gap: 8px;
                "
              >
                <!-- Tags de fuente y aptitud -->
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    gap: 4px;
                    align-items: center;
                  "
                >
                  <span
                    v-for="(src, i) in item.Sources"
                    :key="`src-${i}`"
                    :style="getSourceStyle(src)"
                    style="
                      font-size: 10px;
                      font-weight: 500;
                      padding: 2px 8px;
                      border-radius: 4px;
                      letter-spacing: 0.04em;
                    "
                    >{{ src }}</span
                  >
                  <span
                    v-for="(st, i) in item.Statuses"
                    :key="`st-${i}`"
                    :style="getStatusStyle(st)"
                    style="
                      font-size: 10px;
                      font-weight: 500;
                      padding: 2px 8px;
                      border-radius: 4px;
                      letter-spacing: 0.04em;
                    "
                    >{{ st }}</span
                  >
                </div>

                <div
                  style="height: 0.5px; background: rgba(0, 0, 0, 0.08)"
                ></div>

                <!-- Doctor -->
                <div
                  v-if="item.Doctors.length > 0"
                  style="display: flex; align-items: flex-start; gap: 6px"
                >
                  <span
                    style="
                      font-size: 10px;
                      color: #aaa;
                      letter-spacing: 0.05em;
                      text-transform: uppercase;
                      min-width: 52px;
                      padding-top: 2px;
                    "
                    >Doctor</span
                  >
                  <span
                    v-for="(doc, i) in item.Doctors"
                    :key="`doc-${i}`"
                    style="
                      font-size: 11px;
                      color: #555;
                      border: 0.5px solid rgba(0, 0, 0, 0.12);
                      border-radius: 4px;
                      padding: 2px 8px;
                    "
                    >{{ doc }}</span
                  >
                </div>

                <!-- Diagnósticos -->
                <div style="display: flex; align-items: flex-start; gap: 6px">
                  <span
                    style="
                      font-size: 10px;
                      color: #aaa;
                      letter-spacing: 0.05em;
                      text-transform: uppercase;
                      min-width: 52px;
                      padding-top: 2px;
                    "
                    >Dx</span
                  >
                  <div style="display: flex; flex-direction: column; gap: 2px">
                    <div
                      v-for="(diag, i) in item.Diagnoses"
                      :key="`diag-${i}`"
                      style="
                        font-size: 12px;
                        color: #555;
                        display: flex;
                        align-items: center;
                        gap: 5px;
                      "
                    >
                      <span
                        style="
                          width: 3px;
                          height: 3px;
                          border-radius: 50%;
                          background: #bbb;
                          flex-shrink: 0;
                          display: inline-block;
                        "
                      ></span>
                      {{ diag }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo de Detalle de Amonestaciones/Faltas -->
    <hmn-admonition-detail-dialog
      v-model="admonitionDialog"
      :applicant="selectedAdmonitionApplicant"
    />

    <!-- Template oculto para renderizado de tarjeta de invitación -->
    <div
      style="position: absolute; left: -9999px; top: 0; pointer-events: none"
    >
      <div
        ref="invitationTemplate"
        class="invitation-template-render"
        v-html="invitationTemplateHtml"
      ></div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import SCrud from "@/components/Utils/SCrud.vue";
import SText from "@/components/Utils/SText.vue";
import MassiveService from "@/services/HumanResource/RecruitmentMassive/HmnMassiveRecruitmentService";
import MyMassiveService from "@/services/HumanResource/HmnMyMassiveRecruitmentService";
import PublicRecruitmentService from "@/services/HumanResource/RecruitmentMassive/HmnPublicRecruitmentService";
import WhatsAppService from "@/services/General/WhatsAppService";
import HmnPublicRecruitmentInvitationService from "@/services/HumanResource/RecruitmentMassive/HmnPublicRecruitmentInvitationService";
import s_HistoryRecord from "@/services/HumanResource/HistoryRecordService";
import HmnRecruitmentProcessService from "@/services/HumanResource/RecruitmentProcess/HmnRecruitmentProcessService";
import ContactEventService from "@/services/HumanResource/RecruitmentMassive/HmnPublicRecruitmentContactEventService";
import HmnAdmonitionDetailDialog from "@/components/HumanResource/Recruitment/HmnAdmonitionDetailDialog.vue";

export default {
  name: "HmnMassiveRecruitment",
  components: {
    SCrud,
    SText,
    HmnAdmonitionDetailDialog,
  },
  props: {
    isMyProcesses: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      admonitionDialog: false,
      selectedAdmonitionApplicant: null,
      invitationTemplateHtmlRaw: "",
      invitationBackgroundImageDataUrl: "",
      invitationLogoDataUrl: "",
      invitationAssetsLoaded: false,
      invitationTemplateHtml: "",
      massiveForm: {
        CmpID: null,
        MrcDescription: "",
      },
      timelineDialog: false,
      timelineLoading: false,
      timelineItems: [],
      timelineWorkerName: "",
      savingMassive: false,
      selectedMassive: null,
      selectedApplicants: [],
      refreshMassiveTable: false,
      refreshApplicantsTable: false,
      whatsAppDialog: false,
      sendingWhatsApp: false,
      whatsAppForm: {
        channel: "email",
        dateText: "",
        timeText: "",
        addressText: "Planta Tambogrande",
      },
      filterApplicants: {
        MrcID: 0,
        PstID: 0,
        IsOldWorker: null,
        HasAdmonition: null,
      },
      oldWorkerOptions: [
        { text: "Antiguo (Sí)", value: true },
        { text: "Nuevo (No)", value: false },
      ],
      admonitionFilterOptions: [
        { text: "Con Falta / Amonestación", value: true },
        { text: "Sin Amonestación", value: false },
      ],
      configMassive: {
        service: MassiveService,
        model: {
          MrcID: "ID",
          SecCreate: "datetime",
          CmpEndDate: "date",
          MrcStatus: "",
          PublicLink: "",
        },
        headers: [
          {
            text: "ID",
            value: "MrcID",
            width: 70,
            draggable: false,
            sortable: true,
          },
          // { text: " cmpid xd", value: "CmpID", sortable: true },
          { text: "Campaña", value: "CmpName", sortable: true },
          { text: "Descripción", value: "MrcDescription", sortable: true },
          // { text: "UUID", value: "MrcUUID", sortable: false, width: 250 },
          { text: "Estado", value: "MrcStatus", sortable: false, width: 110 },
          {
            text: "Fin campaña",
            value: "CmpEndDate",
            sortable: true,
            width: 120,
          },
          { text: "Creación", value: "SecCreate", sortable: true, width: 160 },
          { text: "Enlace", value: "PublicLink", sortable: false, width: 120 },
        ],
      },
      configApplicants: {
        service: PublicRecruitmentService,
        model: {
          PmaID: "ID",
          NtpBirthDate: "date",
          SecCreate: "datetime",
          TypeSex: "",
          PositionIDsJSON: "",
          PmaStatus: "",
        },
        headers: [
          // { text: "ID", value: "PmaID", width: 70, draggable: false, sortable: true },
          {
            text: "Nombre completo",
            value: "FullName",
            sortable: true,
            width: 220,
          },
          {
            text: "Documento",
            value: "PrsDocumentNumber",
            sortable: true,
            width: 110,
          },
          {
            text: "Teléfono",
            value: "PpnNumberPhone",
            sortable: true,
            width: 130,
          },
          {
            text: "Email",
            value: "PemEmail",
            sortable: true,
            width: 190,
          },
          { text: "Sexo", value: "TypeSex", sortable: false, width: 90 },
          {
            text: "Amonestación",
            value: "HasAdmonition",
            sortable: false,
            width: 120,
          },
          {
            text: "Antiguo",
            value: "IsOldWorker",
            sortable: false,
            width: 90,
          },
          { text: "Estado", value: "PmaStatus", sortable: false, width: 100 },
          {
            text: "Acciones",
            value: "Actions",
            sortable: true,
            width: 150,
          },
        ],
      },
      positions: [],
      filterTypeProcess: null,
      activeChatApplicant: null,
      chatMessages: [],
      chatText: "",
      chatLoading: false,
      sendingChat: false,
      chatPolling: null,
      processOptions: [],
      loadingProcesses: false,
      bulkSelectDialog: false,
      submittingBulkSelect: false,
      bulkSelectForm: {
        RprID: null,
        PstID: null,
      },
      bulkSelectPositions: [],
      bulkSelectResultsDialog: false,
      bulkSelectResults: [],
      selectedApplicantsForBulk: [],
      whatsAppResultsDialog: false,
      whatsAppResults: [],
    };
  },
  computed: {
    canSendWhatsApp() {
      return !!this.selectedMassive && this.selectedApplicants.length > 0;
    },
    filteredPositions() {
      if (!this.filterTypeProcess) {
        return this.positions;
      }
      return this.positions.filter(
        (p) =>
          p.TypeProcess === this.filterTypeProcess ||
          String(p.TypeProcess) === String(this.filterTypeProcess),
      );
    },
  },
  methods: {
    splitDiagnoses(text) {
      if (!text || typeof text !== "string") return [];

      return text
        .split(/\|+/)
        .map((x) => x.trim())
        .filter((x) => x.length > 0);
    },
    mergeTimelineRows(rows) {
      const byDate = new Map();

      rows.forEach((row) => {
        if (!row || !row.MevDate) return;

        const key = this.$moment(row.MevDate).format("YYYY-MM-DD");
        if (!byDate.has(key)) {
          byDate.set(key, {
            MevDate: key,
            Sources: [],
            Statuses: [],
            Doctors: [],
            Diagnoses: [],
            _diagSet: new Set(),
            _statusSet: new Set(),
            _doctorSet: new Set(),
          });
        }

        const item = byDate.get(key);

        if (row.SourceType && !item.Sources.includes(row.SourceType)) {
          item.Sources.push(row.SourceType);
        }

        const status = (row.MevStatusName || "").trim();
        if (status) {
          const normalizedStatus = status.toLowerCase();
          if (!item._statusSet.has(normalizedStatus)) {
            item._statusSet.add(normalizedStatus);
            item.Statuses.push(status);
          }
        }

        const doctor = (row.DoctorName || "").trim();
        if (doctor) {
          const normalizedDoctor = doctor.toLowerCase();
          if (!item._doctorSet.has(normalizedDoctor)) {
            item._doctorSet.add(normalizedDoctor);
            item.Doctors.push(doctor);
          }
        }

        const split = this.splitDiagnoses(
          row.DiagnosisRaw || row.MevDescriptionDiagnosis || "",
        );
        split.forEach((diag) => {
          const normalized = diag.toLowerCase();
          if (!item._diagSet.has(normalized)) {
            item._diagSet.add(normalized);
            item.Diagnoses.push(diag);
          }
        });
      });

      return Array.from(byDate.values())
        .map((item) => {
          const output = { ...item };
          delete output._diagSet;
          delete output._statusSet;
          delete output._doctorSet;
          return output;
        })
        .sort(
          (a, b) =>
            this.$moment(b.MevDate).valueOf() -
            this.$moment(a.MevDate).valueOf(),
        );
    },
    async openDiagnosisTimeline(row) {
      if (!row || !row.PrsDocumentNumber) {
        this.$fun.alert("No se encontró el DNI del trabajador", "warning");
        return;
      }

      this.timelineDialog = true;
      this.timelineLoading = true;
      this.timelineItems = [];
      this.timelineWorkerName = row.NtpFullName || "";

      try {
        const response = await s_HistoryRecord.getDiagnosisTimeline(
          row.PrsDocumentNumber,
          5,
        );
        const rows = Array.isArray(response?.data) ? response.data : [];
        this.timelineItems = this.mergeTimelineRows(rows);
      } catch (error) {
        this.$fun.alert(
          "No se pudo cargar la línea de tiempo de diagnósticos",
          "error",
        );
      } finally {
        this.timelineLoading = false;
      }
    },
    getMonthLabel(dateStr) {
      const months = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ];
      const parts = dateStr.split("/"); // ajusta según tu formato
      const d = new Date(dateStr);
      return `${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    getSourceStyle(src) {
      const map = {
        "HISTORIA ACTIVA": "background:#ddd6fe;color:#4338ca",
        MASIVO: "background:#d1fae5;color:#065f46",
      };
      return map[src] || "background:#f1f0eb;color:#555";
    },
    getStatusStyle(st) {
      const map = {
        APTO: "background:#dcfce7;color:#166534",
        "APTO C/R": "background:#e0e7ff;color:#3730a3",
        "NO APTO": "background:#fee2e2;color:#991b1b",
      };
      return map[st] || "background:#f1f0eb;color:#555";
    },
    statusColor(status) {
      if (Number(status) === 1) return "#0f766e";
      if (Number(status) === 2) return "#b45309";
      return "#475569";
    },
    applicantStatusColor(status) {
      if (Number(status) === 2) return "#0f766e";
      return "#475569";
    },
    getPublicLink(item) {
      if (!item?.MrcUUID) return "";
      return `${window.location.origin}/convocatoria/${item.MrcUUID}`;
    },
    formatPositionJson(value) {
      if (!value) return "-";
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed.length ? `${parsed.join(", ")}` : "-";
        }
      } catch (error) {}
      return value;
    },
    async createMassive() {
      if (!this.massiveForm.CmpID) {
        this.$fun.alert("Selecciona una campaña", "warning");
        return;
      }

      this.savingMassive = true;
      try {
        const response = await MassiveService.save(
          this.massiveForm,
          this.$fun.getUserID(),
        );
        if (response.status === 200) {
          this.$fun.alert("Convocatoria masiva creada", "success");
          this.massiveForm = {
            CmpID: null,
            MrcDescription: "",
          };
          this.refreshMassiveTable = !this.refreshMassiveTable;
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data.Message || "No se pudo crear",
          "warning",
        );
      } finally {
        this.savingMassive = false;
      }
    },
    openAdmonitionDialog(item) {
      this.selectedAdmonitionApplicant = item;
      this.admonitionDialog = true;
    },
    onMassiveSelected(rows) {
      this.selectedMassive = rows && rows.length ? rows[0] : null;
      this.selectedApplicants = [];
      this.filterTypeProcess = null;
      this.filterApplicants = {
        MrcID: this.selectedMassive ? this.selectedMassive.MrcID : 0,
        PstID: null,
        IsOldWorker: this.filterApplicants.IsOldWorker,
        HasAdmonition: this.filterApplicants.HasAdmonition,
      };
      this.loadCargos(
        this.selectedMassive ? this.selectedMassive.CmpID : 0,
        this.selectedMassive ? this.selectedMassive.MrcID : 0,
      );
      this.refreshApplicantsTable = !this.refreshApplicantsTable;
    },
    onTypeProcessChange() {
      if (this.filterApplicants.PstID && this.filterTypeProcess) {
        const found = this.filteredPositions.find(
          (p) => p.PstID === this.filterApplicants.PstID,
        );
        if (!found) {
          this.filterApplicants.PstID = null;
        }
      }
      this.applyApplicantsFilter();
    },
    applyApplicantsFilter() {
      this.refreshApplicantsTable = !this.refreshApplicantsTable;
    },
    onApplicantsSelected(rows) {
      this.selectedApplicants = Array.isArray(rows) ? rows : [];
    },
    openWhatsAppDialog() {
      if (!this.canSendWhatsApp) {
        this.$fun.alert("Selecciona al menos un postulante", "warning");
        return;
      }

      const now = new Date();
      if (!this.whatsAppForm.dateText) {
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const yyyy = now.getFullYear();
        this.whatsAppForm.dateText = `${dd}/${mm}/${yyyy}`;
      }
      this.whatsAppDialog = true;
    },
    closeWhatsAppDialog() {
      if (this.sendingWhatsApp) return;
      this.whatsAppDialog = false;
    },
    normalizePhone(rawPhone) {
      if (!rawPhone) return null;
      const digits = String(rawPhone).replace(/\D/g, "");
      if (digits.length === 9) return `51${digits}`;
      if (digits.length === 11 && digits.startsWith("51")) return digits;
      return digits.length >= 10 ? digits : null;
    },
    buildApplicantPositions(item) {
      if (item?.AppliedPositions) return item.AppliedPositions;
      return this.formatPositionJson(item?.PositionIDsJSON);
    },
    async getLogoBase64() {
      try {
        const response = await fetch("/static/logo_sp.png");
        if (!response.ok) return "";
        const blob = await response.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve("");
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        return "";
      }
    },
    async ensureInvitationAssetsLoaded() {
      try {
        const resp =
          await HmnPublicRecruitmentInvitationService.getInvitationAssets(
            this.$fun.getUserID(),
          );
        if (resp.data?.TemplateHtml) {
          this.invitationTemplateHtmlRaw = resp.data.TemplateHtml;
        }
        if (resp.data?.BackgroundImageDataUrl) {
          this.invitationBackgroundImageDataUrl =
            resp.data.BackgroundImageDataUrl;
        }
        if (resp.data?.LogoDataUrl) {
          this.invitationLogoDataUrl = resp.data.LogoDataUrl;
        }
      } catch (e) {
        console.warn("No se pudieron cargar assets de invitación vía API:", e);
      }

      // Si no vino de la API, asegurar carga directa de /static/ en Base64
      if (!this.invitationBackgroundImageDataUrl) {
        try {
          const bgBlob = await fetch("/static/WelcomeBGTemplate.png").then(
            (r) => r.blob(),
          );
          this.invitationBackgroundImageDataUrl = await this.blobToBase64(
            bgBlob,
          );
        } catch (err) {
          console.warn("No se pudo cargar /static/WelcomeBGTemplate.png", err);
        }
      }

      if (!this.invitationLogoDataUrl) {
        try {
          const logoBlob = await fetch("/static/logo_sp.png").then((r) =>
            r.blob(),
          );
          this.invitationLogoDataUrl = await this.blobToBase64(logoBlob);
        } catch (err) {
          console.warn("No se pudo cargar /static/logo_sp.png", err);
        }
      }

      // Pre-cargar la imagen de fondo y fuentes una sola vez
      if (this.invitationBackgroundImageDataUrl) {
        const img = new Image();
        img.src = this.invitationBackgroundImageDataUrl;
        await new Promise((resolve) => {
          if (img.complete) resolve();
          else {
            img.onload = () => resolve();
            img.onerror = () => resolve();
            setTimeout(resolve, 300);
          }
        });
      }

      if (document.fonts?.ready) {
        await Promise.race([
          document.fonts.ready,
          new Promise((resolve) => setTimeout(resolve, 400)),
        ]);
      }

      this.invitationAssetsLoaded = true;
    },
    blobToBase64(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => resolve("");
        reader.readAsDataURL(blob);
      });
    },
    formatDateDMY(dateStr) {
      if (!dateStr) return "";
      const cleaned = String(dateStr).trim();
      const m = this.$moment(
        cleaned,
        [
          "YYYY-MM-DD",
          "YYYY/MM/DD",
          "DD/MM/YYYY",
          "D/M/YYYY",
          "DD-MM-YYYY",
          "YYYY-MM-DDTHH:mm:ss",
        ],
        true,
      );
      if (m.isValid()) {
        return m.format("DD/MM/YYYY");
      }
      const mLoose = this.$moment(cleaned);
      if (mLoose.isValid()) {
        return mLoose.format("DD/MM/YYYY");
      }
      return cleaned;
    },
    formatTimeAMPM(timeStr) {
      if (!timeStr) return "";
      const cleaned = timeStr.trim();
      if (/am|pm/i.test(cleaned)) return cleaned;
      const m = this.$moment(cleaned, [
        "HH:mm:ss",
        "HH:mm",
        "H:mm",
        "hh:mm A",
        "hh:mm a",
        "hh:mm",
      ]);
      if (m.isValid()) {
        return m.format("hh:mm A");
      }
      return cleaned;
    },
    renderInvitationHtml(applicant, dateText, timeText, address) {
      let html = this.invitationTemplateHtmlRaw || "";
      const fullName = applicant?.personName || "Postulante";
      const positionName = applicant?.positions || "Puesto Convocado";
      const logoSrc = this.invitationLogoDataUrl || "/static/logo_sp.png";
      const bgSrc =
        this.invitationBackgroundImageDataUrl ||
        "/static/WelcomeBGTemplate.png";
      const formattedDate = this.formatDateDMY(dateText);
      const formattedTime = this.formatTimeAMPM(timeText);

      html = html.replace(/\{\{\s*fullName\s*\}\}/g, fullName);
      html = html.replace(/\{\{\s*positionName\s*\}\}/g, positionName);
      html = html.replace(/\{\{\s*dateText\s*\}\}/g, formattedDate);
      html = html.replace(/\{\{\s*timeText\s*\}\}/g, formattedTime);
      html = html.replace(/\{\{\s*address\s*\}\}/g, address);
      html = html.replace(/\{\{\s*logoUrl\s*\}\}/g, logoSrc);
      html = html.replace(/\{\{\s*backgroundImageUrl\s*\}\}/g, "");

      // Aislar estilos del template para que no afecten el layout global (footer/sidebar/header)
      let scopedStyle = "";
      const styleMatches = [
        ...html.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi),
      ];
      if (styleMatches.length) {
        const rawCss = styleMatches.map((m) => m[1] || "").join("\n");
        const prefixedCss = rawCss.replace(
          /(^|})\s*([^@{}][^{]+)\{/g,
          (full, brace, selectors) => {
            const scopedSelectors = selectors
              .split(",")
              .map((selector) => {
                const s = selector.trim();
                if (!s) return s;
                if (s.startsWith(".invitation-template-render")) return s;
                if (s === "body" || s === "html")
                  return ".invitation-template-render";
                return `.invitation-template-render ${s}`;
              })
              .join(", ");
            return `${brace} ${scopedSelectors} {`;
          },
        );

        scopedStyle = `<style>${prefixedCss}</style>`;
      }

      html = html.replace(/<head[\s\S]*?<\/head>/gi, "");
      html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");
      html = html.replace(/<!DOCTYPE[^>]*>/gi, "");
      html = html.replace(/<html[^>]*>/gi, "");
      html = html.replace(/<\/html>/gi, "");
      html = html.replace(/<body[^>]*>/gi, "");
      html = html.replace(/<\/body>/gi, "");

      if (scopedStyle) {
        html = `${scopedStyle}${html}`;
      }

      if (bgSrc) {
        const bgStyle = `background-image:url('${bgSrc}');background-size:cover;background-position:center bottom;background-repeat:no-repeat;min-height:600px;width:680px;margin:0;padding:28px 36px 30px 36px;box-sizing:border-box;`;
        html = html.replace(
          /<div\s+class=["']container["']\s*>/i,
          `<div class="container" style="${bgStyle}">`,
        );
      }

      return html;
    },
    async generateApplicantCardImage(applicant, dateText, timeText, address) {
      this.invitationTemplateHtml = this.renderInvitationHtml(
        applicant,
        dateText,
        timeText,
        address,
      );
      await this.$nextTick();

      const el = this.$refs.invitationTemplate;
      if (!el) return null;
      const canvas = await html2canvas(el, {
        allowTaint: true,
        useCORS: true,
        backgroundColor: "#ffffff",
        scale: 1.5,
      });
      const dataUrl = canvas.toDataURL("image/png");
      this.invitationTemplateHtml = ""; // Limpiar el DOM inmediatamente tras la captura
      return dataUrl;
    },
    async sendWhatsAppTemplate() {
      if (!this.canSendWhatsApp) {
        this.$fun.alert("Selecciona al menos un postulante", "warning");
        return;
      }

      if (!this.whatsAppForm.dateText || !this.whatsAppForm.timeText) {
        this.$fun.alert("Completa fecha y hora", "warning");
        return;
      }

      const formattedDate = this.formatDateDMY(this.whatsAppForm.dateText);
      const formattedTime = this.formatTimeAMPM(this.whatsAppForm.timeText);

      // ----------------------------------------------------
      // ENVIO POR CORREO ELECTRÓNICO (CANAL POR DEFECTO)
      // ----------------------------------------------------
      if (this.whatsAppForm.channel === "email") {
        console.log("correos", this.selectedApplicants);
        const applicants = this.selectedApplicants
          .map((item) => ({
            pmaID: item.PmaID || 0,
            mrcID: this.selectedMassive ? this.selectedMassive.MrcID : 0,
            pstID: this.filterApplicants.PstID || null,
            email: item.PemEmail ? item.PemEmail.trim() : null,
            personName: item.FullName || "Postulante",
            positions: this.filterApplicants.PstID
              ? this.positions.find(
                  (p) => p.PstID === this.filterApplicants.PstID,
                )?.PstName || "Cargo"
              : this.buildApplicantPositions(item) || "Cargo",
          }))
          .filter((item) => !!item.email);

        if (!applicants.length) {
          this.$fun.alert(
            "Ningún postulante seleccionado tiene correo electrónico válido",
            "warning",
          );
          return;
        }

        this.sendingWhatsApp = true;
        try {
          await this.ensureInvitationAssetsLoaded();

          // Generar tarjeta gráfica en imagen para cada postulante (Opción B)
          for (const app of applicants) {
            try {
              app.imageBytes = await this.generateApplicantCardImage(
                app,
                formattedDate,
                formattedTime,
                this.whatsAppForm.addressText,
              );
            } catch (err) {
              console.warn(
                `No se pudo generar tarjeta para ${app.personName}:`,
                err,
              );
            }
          }

          const payload = {
            dateText: formattedDate,
            timeText: formattedTime,
            address: this.whatsAppForm.addressText,
            applicants: applicants,
          };

          const response =
            await HmnPublicRecruitmentInvitationService.sendEmailInvitations(
              payload,
              this.$fun.getUserID(),
            );

          const sent = response?.data?.sent || 0;
          const failed = response?.data?.failed || 0;
          const errors = response?.data?.errors || [];

          this.$fun.alert(
            `Envío de correos finalizado. Enviados: ${sent}, Fallidos: ${failed}`,
            failed ? "warning" : "success",
          );

          if (failed > 0 && errors.length > 0) {
            this.whatsAppResults = errors;
            this.whatsAppResultsDialog = true;
          }

          this.refreshApplicantsTable = !this.refreshApplicantsTable;

          if (!failed) {
            this.whatsAppDialog = false;
          }
        } catch (error) {
          this.$fun.alert(
            error?.response?.data ||
              "No se pudo enviar las invitaciones por correo",
            "error",
          );
        } finally {
          this.sendingWhatsApp = false;
        }
        return;
      }

      // ----------------------------------------------------
      // ENVIO POR WHATSAPP (CANAL ALTERNATIVO)
      // ----------------------------------------------------
      console.log("selected applicants: ", this.selectedApplicants);
      console.log("selected filterApplicants: ", this.filterApplicants);
      const applicants = this.selectedApplicants
        .map((item) => ({
          pmaID: item.PmaID || 0,
          mrcID: this.selectedMassive ? this.selectedMassive.MrcID : 0,
          pstID: this.filterApplicants.PstID || null,
          phoneNumber: this.normalizePhone(item.PpnNumberPhone),
          personName: item.FullName || "Postulante",
          // en position seleccionar la posicion del filtro si es que hay, sino mostrar todos los cargos postulados
          positions: this.filterApplicants.PstID
            ? this.positions.find(
                (p) => p.PstID === this.filterApplicants.PstID,
              )?.PstName || "Cargo"
            : this.buildApplicantPositions(item) || "Cargo",
        }))
        .filter((item) => !!item.phoneNumber);

      if (!applicants.length) {
        this.$fun.alert(
          "Ningún postulante seleccionado tiene teléfono válido",
          "warning",
        );
        return;
      }

      this.sendingWhatsApp = true;
      try {
        const payload = {
          templateName: "hola_acercate",
          languageCode: "es_PE",
          templateParameters: [
            {
              component: "header",
              source: "personName",
              parameterName: "persona",
            },
            {
              component: "body",
              source: "dateText",
              parameterName: "date",
              type: "text",
            },
            {
              component: "body",
              source: "timeText",
              parameterName: "hora",
              type: "text",
            },
            {
              component: "body",
              source: "positions",
              parameterName: "positions",
            },
          ],
          dateText: formattedDate,
          timeText: formattedTime,
          applicants,
        };

        const response = await WhatsAppService.sendTemplateMeta(
          payload,
          this.$fun.getUserID(),
        );
        const sent = response?.data?.sent || 0;
        const failed = response?.data?.failed || 0;
        const errors = response?.data?.errors || [];

        this.$fun.alert(
          `Envío finalizado. Enviados: ${sent}, Fallidos: ${failed}`,
          failed ? "warning" : "success",
        );

        if (failed > 0 && errors.length > 0) {
          this.whatsAppResults = errors;
          this.whatsAppResultsDialog = true;
        }

        this.refreshApplicantsTable = !this.refreshApplicantsTable;

        if (!failed) {
          this.whatsAppDialog = false;
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo enviar WhatsApp",
          "error",
        );
      } finally {
        this.sendingWhatsApp = false;
      }
    },
    async loadCargos(cmpID, mrcID) {
      if (this.isMyProcesses && !this.$fun.getSecurity().IsLevelAdmin) {
        if (!mrcID) {
          this.positions = [];
          return;
        }
        try {
          const response = await MyMassiveService.myPositions(
            mrcID,
            this.$fun.getUserID(),
          );
          this.positions =
            response.status === 200 && Array.isArray(response.data)
              ? response.data
              : [];
        } catch (error) {
          this.positions = [];
          this.$fun.alert(
            "No se pudieron cargar los cargos asignados de la convocatoria",
            "warning",
          );
        }
      } else {
        if (!cmpID) {
          this.positions = [];
          return;
        }

        try {
          const response = await MassiveService.GetAvailablePositions(cmpID);
          this.positions =
            response.status === 200 && Array.isArray(response.data)
              ? response.data
              : [];
        } catch (error) {
          this.positions = [];
          this.$fun.alert(
            "No se pudieron cargar los cargos de la campaña seleccionada",
            "warning",
          );
        }
      }
    },
    async loadAllActiveProcesses() {
      this.loadingProcesses = true;
      try {
        const parameters = {
          draw: 1,
          start: 0,
          length: 500,
          searchText: "",
          filter: {
            ModuleType: 1,
            AllProcesses: true,
          },
        };
        const response = await HmnRecruitmentProcessService.pagination(
          parameters,
          this.$fun.getUserID(),
        );
        const rows = response?.data?.data || [];
        this.processOptions = rows
          .filter((item) => Number(item?.RprStatus) === 1)
          .map((item) => ({
            text: `Proc. N° ${item.RprID} - ${
              item.RequestedPosition || item.ReqName || "Convocatoria"
            }`,
            value: item.RprID,
            cmpID: item.CmpID,
            pstName: item.RequestedPosition,
          }));
      } catch (error) {
        console.error("Error al cargar procesos activos:", error);
      } finally {
        this.loadingProcesses = false;
      }
    },
    async onBulkSelectProcessChanged(rprID) {
      this.bulkSelectForm.PstID = null;
      this.bulkSelectPositions = [];
      if (!rprID) return;

      const process = this.processOptions.find((p) => p.value === rprID);
      if (process && process.cmpID) {
        try {
          const response = await MassiveService.GetAvailablePositions(
            process.cmpID,
          );
          this.bulkSelectPositions =
            response.status === 200 && Array.isArray(response.data)
              ? response.data
              : [];
        } catch (error) {
          console.error("Error al cargar cargos del proceso:", error);
        }
      }
    },
    openSingleSelectDialog(applicant) {
      if (!applicant) return;
      this.selectedApplicantsForBulk = [applicant];
      this.bulkSelectForm.RprID = null;
      this.bulkSelectForm.PstID = null;
      this.bulkSelectPositions = [];
      this.bulkSelectDialog = true;
    },
    openBulkSelectDialog() {
      if (this.selectedApplicants.length === 0) return;
      this.selectedApplicantsForBulk = [...this.selectedApplicants];
      this.bulkSelectForm.RprID = null;
      this.bulkSelectForm.PstID = null;
      this.bulkSelectPositions = [];
      this.bulkSelectDialog = true;
    },
    async confirmBulkSelect() {
      if (!this.bulkSelectForm.RprID) {
        this.$fun.alert("Seleccione un proceso", "warning");
        return;
      }

      this.submittingBulkSelect = true;
      try {
        const payload = {
          PmaIDs: this.selectedApplicantsForBulk.map((a) => a.PmaID),
          RprID: this.bulkSelectForm.RprID,
          PstID: this.bulkSelectForm.PstID || 0,
        };

        const response = await PublicRecruitmentService.bulkSelect(
          payload,
          this.$fun.getUserID(),
        );
        if (response.status === 200) {
          this.bulkSelectDialog = false;
          this.bulkSelectResults = response.data.Rows || [];
          this.bulkSelectResultsDialog = true;

          if (this.activeChatApplicant) {
            const hasChattedApplicant = this.selectedApplicantsForBulk.some(
              (a) => a.PmaID === this.activeChatApplicant.PmaID,
            );
            if (hasChattedApplicant) {
              this.closeChat();
            }
          }

          this.refreshApplicantsTable = !this.refreshApplicantsTable;
          this.selectedApplicants = [];
          if (this.$refs.scrudApplicants) {
            this.$refs.scrudApplicants.selected = [];
          }
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data?.Message ||
            "Ocurrió un error al procesar la selección",
          "error",
        );
      } finally {
        this.submittingBulkSelect = false;
      }
    },
    async rejectApplicant(item) {
      if (!item) return;
      const ok = await this.$fun.confirm(
        "¿Está seguro de rechazar a este postulante?",
      );
      if (!ok) return;

      try {
        const response = await PublicRecruitmentService.setStatus(
          item.PmaID,
          0,
          this.$fun.getUserID(),
        );
        if (response.status === 200) {
          this.$fun.alert("Postulante rechazado", "success");
          if (
            this.activeChatApplicant &&
            this.activeChatApplicant.PmaID === item.PmaID
          ) {
            this.closeChat();
          }
          this.refreshApplicantsTable = !this.refreshApplicantsTable;
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo cambiar el estado",
          "error",
        );
      }
    },
    openChat(item) {
      this.activeChatApplicant = item;
      this.chatMessages = [];
      this.chatText = "";
      this.chatLoading = true;
      this.loadChatMessages();

      if (this.chatPolling) {
        clearInterval(this.chatPolling);
      }
      this.chatPolling = setInterval(() => {
        this.loadChatMessages();
      }, 30000);
    },
    closeChat() {
      if (this.chatPolling) {
        clearInterval(this.chatPolling);
        this.chatPolling = null;
      }
      this.activeChatApplicant = null;
      this.chatMessages = [];
      this.chatText = "";
    },
    async loadChatMessages() {
      if (!this.activeChatApplicant) return;
      try {
        const dtr = {
          draw: 1,
          start: 0,
          length: 100,
          orderColumn: "EventID",
          orderDir: "desc",
          searchText: "",
          filter: JSON.stringify({
            PmaID: this.activeChatApplicant.PmaID,
            MrcID: this.activeChatApplicant.MrcID,
          }),
        };

        const response = await ContactEventService.paginate(
          dtr,
          this.$fun.getUserID(),
        );
        if (response.status === 200 && response.data && response.data.data) {
          this.chatMessages = response.data.data.slice().reverse();
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      } catch (error) {
        console.error("Error al cargar mensajes del chat:", error);
      } finally {
        this.chatLoading = false;
      }
    },
    async sendChatMessage() {
      if (!this.chatText || !this.chatText.trim()) return;
      if (!this.activeChatApplicant) return;

      this.sendingChat = true;
      try {
        const payload = {
          PmaID: this.activeChatApplicant.PmaID,
          MrcID: this.activeChatApplicant.MrcID,
          PhoneNumber: this.activeChatApplicant.PpnNumberPhone,
          MessageText: this.chatText,
        };

        const response = await WhatsAppService.sendCustomText(
          payload,
          this.$fun.getUserID(),
        );
        if (response.status === 200) {
          this.chatText = "";
          await this.loadChatMessages();
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data || "No se pudo enviar el mensaje",
          "error",
        );
      } finally {
        this.sendingChat = false;
      }
    },
    scrollToBottom() {
      const container = this.$refs.chatContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
    formatChatTime(dateStr) {
      if (!dateStr) return "";
      return this.$moment(dateStr).format("DD/MM HH:mm");
    },
    getAppliedPositionsList(item) {
      if (!item) return [];
      if (item.AppliedPositions) {
        return item.AppliedPositions.split(",").map((p) => p.trim());
      }
      const posJson = this.formatPositionJson(item.PositionIDsJSON);
      if (posJson && posJson !== "-") {
        return posJson.split(",").map((p) => p.trim());
      }
      return [];
    },
  },
  async mounted() {
    await this.loadAllActiveProcesses();
  },
  created() {
    if (this.isMyProcesses) {
      this.configMassive.service = MyMassiveService;
      if (!this.$fun.getSecurity().IsLevelAdmin) {
        this.configApplicants.service = {
          pagination: (parameters, requestID) => {
            return MyMassiveService.paginationApplicants(parameters, requestID);
          },
        };
      }
    }
  },
  beforeDestroy() {
    if (this.chatPolling) {
      clearInterval(this.chatPolling);
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:wght@600&family=Manrope:wght@400;600;700&display=swap");

.mrc-page {
  --ink: #1f2937;
  --muted: #6b7280;
  --accent: #0f766e;
  --border: #e2e8f0;
  background: radial-gradient(
    circle at top right,
    #f4f5f8 0%,
    #f8fafc 45%,
    #f2f7f6 100%
  );
  min-height: 100vh;
  padding: 24px;
  font-family: "Manrope", sans-serif;
  color: var(--ink);
}

.mrc-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(120deg, #0f172a, #1f2937);
  color: #f8fafc;
  border-radius: 18px;
  padding: 22px 28px;
  margin-bottom: 22px;
}

.mrc-hero__kicker {
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.7rem;
  color: rgba(248, 250, 252, 0.65);
}

.mrc-hero__title {
  font-family: "Fraunces", serif;
  font-size: 1.7rem;
  margin: 6px 0 4px;
}

.mrc-hero__subtitle {
  margin: 0;
  color: rgba(248, 250, 252, 0.65);
}

.mrc-hero__badge {
  background: rgba(15, 118, 110, 0.5);
  padding: 8px 18px;
  border-radius: 999px;
}

.mrc-container {
  max-width: 1400px;
}

.mrc-card {
  border-radius: 16px;
  border: 1px solid var(--border);
  background: #ffffff;
}

.mrc-card__header {
  padding: 16px 20px 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.mrc-card__header span {
  color: var(--muted);
  font-size: 0.85rem;
}

.mrc-card--composer :deep(.v-input__slot) {
  background: #fff;
}

.mrc-detail {
  margin-top: 14px;
  display: grid;
  gap: 10px;
  background: #f0fdf4;
  padding: 12px;
  border-radius: 12px;
  font-size: 0.9rem;
}

.mrc-detail--selected {
  margin-top: 0;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.mrc-detail span {
  color: var(--muted);
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.mrc-card--applicants {
  margin-bottom: 24px;
}

.mrc-template-flags {
  margin-bottom: 10px;
}

.mrc-param-box {
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 10px 12px 6px;
  background: #f8fafc;
}

.mrc-param-box__title {
  font-size: 0.8rem;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}

/* Chat styles */
.mrc-card--chat {
  display: flex;
  flex-direction: column;
  height: 520px;
  overflow: hidden;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.mrc-chat-header {
  text-transform: uppercase;
  padding: 14px 18px;
  background: #ffffff;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mrc-chat-positions-bar {
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.mrc-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mrc-chat-bubble-wrapper {
  display: flex;
  width: 100%;
}

.mrc-chat-bubble-wrapper.inbound {
  justify-content: flex-start;
}

.mrc-chat-bubble-wrapper.outbound {
  justify-content: flex-end;
}

.mrc-chat-bubble {
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 0.875rem;
  line-height: 1.4;
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.inbound .mrc-chat-bubble {
  background: #ffffff;
  color: #1e293b;
  border-bottom-left-radius: 2px;
}

.outbound .mrc-chat-bubble {
  background: #0f766e;
  color: #ffffff;
  border-bottom-right-radius: 2px;
}

.mrc-chat-bubble-meta {
  font-size: 0.75rem;
  margin-bottom: 4px;
  opacity: 0.8;
}

.mrc-chat-bubble-text {
  white-space: pre-wrap;
}

.mrc-chat-bubble-time {
  font-size: 0.7rem;
  margin-top: 4px;
  opacity: 0.7;
}

.mrc-chat-footer {
  background: #ffffff;
  border-top: 1px solid var(--border);
}

/* Scrollbar styles for messages */
.mrc-chat-messages::-webkit-scrollbar {
  width: 6px;
}

.mrc-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.mrc-chat-messages::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
}

.invitation-template-render {
  width: 680px;
  background-color: #ffffff;
}
</style>
